import * as React from 'react';
import { getMonth, getYear } from 'date-fns';
import { Input } from '../../Input/Input';


var MENU_MAX_HEIGHT = 200;
export var DatePickerHeader = function (_a) {
    var changeMonth = _a.changeMonth, changeYear = _a.changeYear, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, nextMonthButtonDisabled = _a.nextMonthButtonDisabled, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, monthOptions = _a.monthOptions, date = _a.date, monthSelectionLabel = _a.monthSelectionLabel;
    var currentMonthOption = monthOptions.find(function (option) {
        return getMonth(option.id) === getMonth(date) &&
            getYear(option.id) === getYear(date);
    });
    var handleMonthChange = React.useCallback(function (_a) {
        var value = _a.value;
        var valueAsMonthOption = value;
        var date = valueAsMonthOption.id;
        changeMonth(getMonth(date));
        changeYear(getYear(date));
    }, [changeMonth, changeYear]);
    return (React.createElement("div", { className: "pluggy DatePickerHeader" },
        React.createElement("div", { onClick: !prevMonthButtonDisabled ? decreaseMonth : undefined, className: "navigation-arrow-previous " + (prevMonthButtonDisabled ? 'disabled' : '') }),
        React.createElement(Input, { type: 'select', options: monthOptions, onChange: handleMonthChange, value: currentMonthOption, label: monthSelectionLabel || 'Selecione um mês', maxMenuHeight: MENU_MAX_HEIGHT }),
        React.createElement("div", { onClick: !nextMonthButtonDisabled ? increaseMonth : undefined, className: "navigation-arrow-next " + (nextMonthButtonDisabled ? 'disabled' : '') })));
};
